<template>
  <page>
    <div>
      <v-card>
        <form>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card-text>
                    <div slot="header">
                        <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                    </div>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xs12 md4 lg6>
                              <cal-picker v-model="form.dFromDate" :label="label.dFromDate" :data-vv-as="label.dFromDate" data-vv-name="form.dFromDate" :error-messages="errors.collect('form.dFromDate')" v-validate="'required|start_after_today'"></cal-picker>
                            </v-flex>
                            <v-flex xs12 md4 lg6>
                              <cal-picker v-model="form.dToDate" :label="label.dToDate" :data-vv-as="label.dToDate" data-vv-name="form.dToDate" :error-messages="errors.collect('form.dToDate')" v-validate="toDateValidation(form.dFromDate)"></cal-picker>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs12 lg4>
                              <v-autocomplete :label="label.cPropStat" :items="cPropStatOpList" v-model="filters.cPropStat" item-text="label" item-value="value" data-vv-name="filters.cPropStat" :data-vv-as="label.cPropStat" :error-messages="errors.collect('filters.cPropStat')" @change="doPropStatFilters"></v-autocomplete>
                            </v-flex>
                            <v-flex v-if="filters.cPropStat === 'S'" xs12 lg8>
                              <v-autocomplete multiple :label="label.sPropStatOpt" :items="propStatList" v-model="filters.cPropStatList" item-text="label" item-value="value" data-vv-name="filters.cPropStatList" :data-vv-as="label.propStatList" :error-messages="errors.collect('filters.cPropStatList')" @change="doCheckFilters" v-validate="'required'"></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card>
      <v-spacer class="mt-2"></v-spacer>
      <v-flex xs12>
          <v-expansion-panels v-model="panel4" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Report Setting</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-checkbox
                      :label="label.pbPrtParam"
                      v-model="form.pbPrtParam"
                      :error-messages="errors.collect('pbPrtParam')"
                      data-vv-name="pbPrtParam"
                      :data-vv-as="label.pbPrtParam"
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
      <v-form>
        <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{label.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
      </v-form>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { cPropStat } from '@/const/underwriting'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      form: {
        dFromDate: null,
        dToDate: null,
        format: undefined,
        cPropStat: '',
        cPropStatList: '',
        pbPrtParam: true
      },
      label: {
        dFromDate: 'From Proposal Date',
        dToDate: 'To Proposal Date',
        format: 'Export Format',
        export: 'Export to',
        cPropStat: 'Proposal Status',
        sPropStatOpt: 'Selected Proposal Status(es)',
        pbPrtParam: 'Print Run Time Parameters'
      },
      showClmHelpList: false,
      showPolicyHelpList: false,
      menu: {},
      supportedFormat: [],
      loading: false,
      validatePolNo: '',
      validateClmNo: '',
      filters: {
        cPropStat: 'A',
        cPropStatList: []
      },
      propStatList: []
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initPropChkList
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.getPropStatList()
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      this.form.cPropStatList = ''
      for (let i in this.filters.cPropStatList) {
        this.form.cPropStatList += this.filters.cPropStatList[i] + ','
      }
      this.form.cPropStatList = this.form.cPropStatList.slice(0, -1)
      this.form.cPropStat = this.filters.cPropStat

      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getPropStatList() {
      const apiURI = this.menu.propStatList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.propStatList = []
          if (data) {
            for (let i in data) {
              this.propStatList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doPropStatFilters() {
      if (this.filters.cPropStat === 'A') {
        this.filters.cPropStatList = []
        this.form.cPropStatList = ''
      }
    },
    async doCheckFilters() {
      if (this.filters.cPropStatList.length === 0) {
        this.filters.cPropStat = 'A'
        this.filters.cPropStatList = []
        this.form.cPropStatList = ''
      }
    },
    toDateValidation(dFromDate) {
      const result = 'required|from_to_date:' + dFromDate
      return result
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    cPropStatOpList() {
      let result = []
      Object.keys(cPropStat).forEach(function (key) {
        const polType = cPropStat[key]
        result.push({
          value: key,
          label: polType
        })
      })
      return result
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return 'Entry Date To must be equal or greater than Entry Date From'
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          return (isAfter(tomorrow, startDate))
        } else return true
      }
    })
  },
  watch: {
  },
  mixins: [
    MessageMixin
  ]
}

</script>
